<fin-check-in-passenger-info-box
  class="mr-small-b"
  [passenger]="passenger"
  [accompanyingAdult]="accompanyingAdult"
  [accompanyingInfant]="accompanyingInfant"
  [showEdit]="(!modifyCheckIn && !passenger.isCheckedIn) || modifyCheckIn"
  [modifyCheckIn]="modifyCheckIn"
  [formGroup]="formGroup"
  (edit)="togglePassengerInfo(true)"
>
</fin-check-in-passenger-info-box>

<fcom-modal
  *ngIf="passengerGroup$ | async as passengerFormGroup"
  [title]="passenger.firstName + ' ' + passenger.lastName"
  [open]="editingPassenger$ | async"
  [fitToContent]="true"
  [overlayClickable]="(isSaving$ | async) === false"
  [forceRemainOpen]="isSaving$ | async"
  [buttons]="ModalButtons.CUSTOM"
  (close)="editingPassenger$.next(false)"
>
  <div class="pr-small" [formGroup]="passengerFormGroup">
    <fin-pax-details-form-group
      [showContactDetails]="true"
      [hideDisabledFields]="true"
      [groupIndex]="paxIndex"
      [hideGroups]="hideGroups"
      [passengerFormGroup]="passengerFormGroup"
      [controlData]="controlData$ | async"
      [isMainPassenger]="isMainPax"
      [frequentFlyerAirlines$]="frequentFlyerAirlines | finToObservable"
      [availableDates]="availableDays"
      [allowMultipleFFCards]="true"
      [trackingContext]="trackingContext"
      [allFrequentFlyerCards]="allFrequentFlyerCards$ | async"
      [showCopyDetailsButton]="!!passenger.email && passengersWithoutInfants.length > 1"
      [copyFromPassengersList]="passengersToCopy"
      (copyDetailsClicked)="copyContactDetailsToAll(passengerFormGroup)"
    >
    </fin-pax-details-form-group>
  </div>
  <div buttons>
    <ng-container *finLet="isSaving$ | async as isSaving">
      <fcom-button
        data-testid="cancel-button"
        class="ms-small-r"
        *ngIf="editingPassenger$ | async"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [text]="'actions.cancel' | finLocalization"
        [disabled]="isSaving"
        (clickBtn)="togglePassengerInfo(false)"
      ></fcom-button>
      <fcom-button
        data-testid="save-button"
        *ngIf="editingPassenger$ | async"
        [loading]="isSaving"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        [icon]="isSaving ? { name: SvgLibraryIcon.TRANSFER_LOADER, position: IconPosition.RIGHT } : null"
        [text]="'MMB.labels.saveDetails' | finLocalization"
        [disabled]="!passengerFormGroup.valid"
        (clickBtn)="saveDetails(passengerFormGroup)"
      ></fcom-button>
    </ng-container>
  </div>
</fcom-modal>
